import { combineReducers } from 'redux'

import common from './common'
import experiments from './experiments'
import { IState as HomePageState, reducer as homePage } from './homePage'
import landingPage from './landingPage'
import layout from './layout'
import { IState as IMarketingState, reducer as marketing } from './marketing'
import { IState as SearchPageState, reducer as searchPage } from './searchPage'
import user from './user'

export interface IRootState {
  common: any
  homePage: HomePageState
  landingPage: any
  layout: any
  marketing: IMarketingState
  searchPage: SearchPageState
  user: any
  experiments: any
}

export const rootReducer = combineReducers<IRootState>({
  common,
  experiments,
  homePage,
  landingPage,
  layout,
  marketing,
  searchPage,
  user
})



// WEBPACK FOOTER //
// ./common/reducers/index.ts